import { Component, Input, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { saveAs } from "file-saver";
import { DateHelper } from "../../../helpers/DateHelper";
import { VehicleIncomeReport } from "../../../models/vehicles/vehicle.income.report";
import { VehicleIncomeReportFilter } from "../../../models/vehicles/vehicle.income.report.filter";
import { AlertService } from "../../../services/alert.service";
import { VehicleService } from "../../../services/vehicle.service";
import { CashoutFormDialogComponent } from "../cashout-form-dialog/cashout-form-dialog.component";
import { VehicleCashout } from "./../../../models/vehicles/vehicle-cashout";
import { VehicleCashoutService } from "./../../../services/vehicle-cashout.service";

@Component({
  selector: "vehicle-expenses",
  templateUrl: "./vehicle-expenses.component.html",
  styleUrls: ["./vehicle-expenses.component.css"],
})
export class VehicleExpensesComponent implements OnInit {
  @Input() vehicleId: number = 0;

  report: VehicleIncomeReport;
  allTimeReport: VehicleIncomeReport;
  filter: VehicleIncomeReportFilter;

  constructor(
    private _vehicleService: VehicleService,
    private _dialog: MatDialog,
    private _vehicleCashoutService: VehicleCashoutService,
    private _alertService: AlertService
  ) {}

  ngOnInit() {
    this.init();
    this.fetchAllTime();
  }

  init() {
    this.report = new VehicleIncomeReport();
    this.filter = new VehicleIncomeReportFilter();
    this.filter.vehicleId = this.vehicleId;
    this.filter.isPaid = null;

    let period = DateHelper.getMonthlyPeriod(new Date());
    this.filter.tripDateFrom = period.from;
    this.filter.tripDateTo = period.to;
    this.fetch();
  }

  fetch() {
    this._vehicleService.getReport(this.filter).subscribe((result) => {
      if (result != undefined) {
        this.report = result;
      }
    });
  }

  fetchAllTime() {
	this._vehicleService.getReport({
		vehicleId: this.vehicleId,
		tripDateFrom: "1990-01-01",
		tripDateTo: "3999-01-01",
    isPaid: true
	  } as VehicleIncomeReportFilter).subscribe((result) => {
		if (result != undefined) {
		  this.allTimeReport = result;
		}
	  });
  }

  export() {
    this._vehicleService.exportReport(this.filter).subscribe((result) => {
      var blob = new Blob([result], { type: "application/vnd.ms-excel" });
      saveAs(
        blob,
        `${this.report.plateNumber} - ${this.filter.tripDateFrom}-${this.filter.tripDateTo}.xlsx`
      );
    });
  }

  openCashoutDialog(cashout: VehicleCashout | undefined) {
    this._dialog.closeAll();
    let dialogRef = this._dialog.open(CashoutFormDialogComponent, {
      data: {
        vehicleId: this.vehicleId,
        id: cashout == undefined ? 0 : cashout.id,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == true) {
        this.fetch();
        this.fetchAllTime();
      }
    });
  }

  deleteCashout(cashout: VehicleCashout) {
    this._vehicleCashoutService
      .deleteVehicleCashout(cashout.id)
      .subscribe((result) => {
        if (result.isSuccess) {
          this.fetch();
          this.fetchAllTime();
        } else {
          this._alertService.showError(result.error);
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/vehicles/vehicle-expenses/vehicle-expenses.component.ts